var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Quill from 'quill';
var embed = Quill.import('blots/embed');
var TextHintPlaceholderEmbed = /** @class */ (function (_super) {
    __extends(TextHintPlaceholderEmbed, _super);
    function TextHintPlaceholderEmbed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextHintPlaceholderEmbed.create = function (options) {
        var _a;
        var node = _super.create.call(this, 'button');
        var classes = 'my-sm p-md w-full h-20 flex items-center justify-center text-elephant dashed-gradient rounded font-semibold'.split(' ');
        node.innerText = options.title;
        (_a = node.classList).add.apply(_a, classes);
        node.dataset.blotId = options.id;
        node.addEventListener('click', (function () { return options.click(options); }));
        return node;
    };
    TextHintPlaceholderEmbed.value = function (node) {
        var options = {
            id: node.dataset.blotId,
            title: node.innerText,
            click: null,
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        options.click = function () { return node.click(options); };
        return options;
    };
    TextHintPlaceholderEmbed.blotName = 'TextHintPlaceholderEmbed';
    TextHintPlaceholderEmbed.className = 'ql-text-hint-placeholder';
    TextHintPlaceholderEmbed.tagName = 'button';
    return TextHintPlaceholderEmbed;
}(embed));
export { TextHintPlaceholderEmbed };
